import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { Map, List } from 'immutable';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Grid } from '@material-ui/core';
import { Toastr, tools } from 'data/common';
import {
    FHEReactSelect,
    FHEContainerForm,
    FHEContainerScroll,
    FHETitle,
    FHETextField,
    FormEditButton,
    FormSaveButton,
    FHEButton,
    FormButtonContainer,
} from 'data/components';
import renderEnvComponent from 'data/common/renderEnvComponent';
import { SvgCraftsman } from 'data/common/iconsvg';
import memoizeOne from 'memoize-one';
import getSelectors from '../../PushNotification/selectors';

class FormUserManager extends Component {
    static propTypes = {
        managementsArray: PropTypes.array.isRequired,
        managementDetailsRights: PropTypes.bool.isRequired,
        detailsRights: PropTypes.bool.isRequired,
        updateRights: PropTypes.bool.isRequired,
        createRights: PropTypes.bool.isRequired,
        resetPassRights: PropTypes.bool.isRequired,
        history: PropTypes.object.isRequired,
        resetPassword: PropTypes.func,
        generateCode: PropTypes.func,
        sendDataFunc: PropTypes.func.isRequired,
        userManager: PropTypes.object.isRequired,
        type: PropTypes.string.isRequired,
        managements: PropTypes.object,
    };

    static defaultProps = {
        resetPassword: null,
        generateCode: null,
        managements: {},
    };

    constructor(props) {
        super(props);
        const { type } = props;

        this.state = {
            passwordReseting: false,
            codeGenerating: false,
            provisionningBox: false,
            formDisabled: type === 'update',
            userManagerForm: this.getDataForm(),
            textInput_error: {},
            sendLoading: false,
        };

        this.roles = [
            { value: 'guest', label: Translator.translate(`generic.userManager.table.guest`) },
            { value: 'user', label: Translator.translate(`generic.userManager.table.user`) },
            { value: 'admin', label: Translator.translate(`generic.userManager.table.admin`) },
            { value: 'developper', label: Translator.translate(`generic.userManager.table.developper`) },
        ];
        this.langs = [
            { value: 'fr_FR', label: Translator.translate(`general.table.column.languages.fr_FR`) },
            { value: 'en_EN', label: Translator.translate(`general.table.column.languages.en_EN`) },
            { value: 'de_DE', label: Translator.translate(`general.table.column.languages.de_DE`) },
        ];
    }

    getSelectedManagements = memoizeOne(managementIds => {
        const { managements } = this.props;

        if (managementIds) {
            return managementIds.reduce((reduction, value) => {
                const management = managements.getIn([value.toString()], new Map());
                return [...reduction, { value, label: management.get('libelle') }];
            }, []);
        }
    });

    getSelectedLang = memoizeOne(formLang => {
        return this.langs.find(lang => lang.value === formLang);
    });

    getSelectedRole = memoizeOne(formRole => {
        return this.roles.find(role => role.value === formRole);
    });

    getDataForm = () => {
        const { type, userManager } = this.props;
        return {
            firstname: type === 'update' ? userManager.get('firstname') : null,
            lastname: type === 'update' ? userManager.get('lastname') : null,
            email: type === 'update' ? userManager.get('email') : null,
            role: type === 'update' ? userManager.get('role') : null,
            lang: type === 'update' ? userManager.get('lang') : null,
            code: type === 'update' ? userManager.get('code') : null,
            title: type === 'update' ? userManager.get('title') : null,
            managementIds: type === 'update' ? userManager.getIn(['managementIds'], new List()).toArray() : null,
            password: null,
        };
    };

    loadInputs = () => {
        this.setState({
            formDisabled: true,
            sendLoading: false,
            userManagerForm: this.getDataForm(),
        });
    };

    handleEdit = () => {
        const { formDisabled, provisionningBox } = this.state;

        if (!formDisabled) this.loadInputs();
        this.setState({
            formDisabled: formDisabled && provisionningBox ? true : !formDisabled,
            provisionningBox: false,
            textInput_error: {},
        });
    };

    handleChange = event => {
        const { userManagerForm, textInput_error } = this.state;
        const fieldLengthRules = {
            firstname: 255,
            lastname: 255,
        };
        const value = tools.maxFieldLength(fieldLengthRules, userManagerForm, event.target);

        this.setState({
            userManagerForm: { ...userManagerForm, [event.target.name]: value },
            textInput_error: tools.removeKey(textInput_error, event.target.name),
        });
    };

    handleReactSelect = (event, options) => {
        const { userManagerForm, textInput_error } = this.state;

        const newTextInput_error = tools.removeKey(textInput_error, options.name);

        if (options.name === 'managementIds') {
            this.setState({
                userManagerForm: {
                    ...userManagerForm,
                    managementIds: event ? event.map(home => home.value) : null,
                },
                textInput_error: newTextInput_error,
            });
        } else {
            this.setState({
                userManagerForm: { ...userManagerForm, [options.name]: event.value },
                textInput_error: newTextInput_error,
            });
        }
    };

    confirmEdit = () => {
        const { userManagerForm } = this.state;
        const { sendDataFunc } = this.props;
        if (this.validateForm(userManagerForm)) {
            this.setState({
                sendLoading: true,
                formDisabled: true,
            });
            return sendDataFunc(userManagerForm)
                .then(() => {
                    Toastr.success(
                        Translator.translate(
                            `generic.userManager.actions.editUserManagerSuccess`,
                            userManagerForm.firstname,
                            userManagerForm.lastname,
                        ),
                    );
                    this.loadInputs();
                    this.setState({
                        formDisabled: true,
                        provisionningBox: false,
                        sendLoading: false,
                    });
                })
                .catch(error => {
                    this.setState({
                        sendLoading: false,
                        formDisabled: false,
                    });
                    Toastr.error(`generic.userManager.actions.editUserManagerError`, userManagerForm.label);
                    if (error.validation && error.validation.errors) {
                        return this.setState({
                            textInput_error: tools.handleFormError(error.validation.errors),
                        });
                    }
                });
        }
    };

    askResetPassword = e => {
        const { userManager } = this.props;
        e.preventDefault();
        Toastr.confirm(
            Translator.translate('generic.userManager.actions.confirmResetPassword', userManager.get('firstname'), userManager.get('lastname')),
            Translator.translate('generic.userManager.actions.resetPasswordTitle'),
            {
                onYes: this.resetPassword,
            },
        );
    };

    askGenerateCode = e => {
        const { userManager } = this.props;
        e.preventDefault();
        Toastr.confirm(
            Translator.translate('generic.userManager.actions.confirmGenerateCode', userManager.get('firstname'), userManager.get('lastname')),
            Translator.translate('generic.userManager.actions.generateCodeTitle'),
            {
                onYes: this.generateCode,
            },
        );
    };

    generateCode = () => {
        const { userManagerForm } = this.state;
        const { generateCode, userManager } = this.props;
        this.setState({
            codeGenerating: true,
        });

        return generateCode()
            .then(r => {
                Toastr.success(
                    Translator.translate(
                        'generic.userManager.actions.generateCodeSuccess',
                        userManager.get('firstname'),
                        userManager.get('lastname'),
                    ),
                );
                this.setState({
                    userManagerForm: { ...userManagerForm, ['code']: r.code },
                    codeGenerating: false,
                });
            })
            .catch(() => {
                Toastr.error(
                    Translator.translate('generic.userManager.actions.generateCodeError', userManager.get('firstname'), userManager.get('lastname')),
                );
            });
    };

    resetPassword = () => {
        const { resetPassword, userManager } = this.props;

        this.setState({
            passwordReseting: true,
        });

        return resetPassword()
            .then(() => {
                Toastr.success(
                    Translator.translate(
                        'generic.userManager.actions.resetPasswordSuccess',
                        userManager.get('firstname'),
                        userManager.get('lastname'),
                    ),
                );
            })
            .catch(() => {
                Toastr.error(
                    Translator.translate('generic.userManager.actions.resetPasswordError', userManager.get('firstname'), userManager.get('lastname')),
                );
            })
            .finally(() => {
                this.setState({
                    passwordReseting: false,
                });
            });
    };

    validateForm = form => {
        const { type } = this.props;
        const arrayCheckEmptyFields =
            type === 'update'
                ? ['firstname', 'lastname', 'role', 'lang', 'managementIds']
                : ['firstname', 'lastname', 'role', 'lang', 'email', 'password'];
        const errors = tools.checkEmptyFields(form, arrayCheckEmptyFields);
        this.setState({
            textInput_error: errors,
        });

        return Object.keys(errors).length <= 0;
    };

    saveUserManager = () => {
        const { userManagerForm } = this.state;
        const { sendDataFunc, history, detailsRights } = this.props;

        if (this.validateForm(userManagerForm)) {
            this.setState({
                formDisabled: true,
                sendLoading: true,
            });
            return sendDataFunc(userManagerForm)
                .then(data => {
                    const userManager = data.userManager;
                    Toastr.success(
                        Translator.translate('generic.userManager.actions.addUserManagerSuccess', userManager.lastname, userManager.firstname),
                    );
                    if (detailsRights)
                        return history.push({
                            pathname: `/${history.environment}/user-manager/detail/${data.userManagerId}`,
                            state: { fromAdd: true },
                        });
                    return history.push(`/${history.environment}/user-manager`);
                })
                .catch(error => {
                    Toastr.error(
                        Translator.translate('generic.userManager.actions.addUserManagerError', userManagerForm.firstname, userManagerForm.lastname),
                    );
                    this.setState({
                        formDisabled: false,
                        sendLoading: false,
                    });
                    if (error.validation && error.validation.errors) {
                        return this.handleFormError(error.validation.errors);
                    }
                });
        }
    };

    // renders
    renderButtons() {
        const { formDisabled, sendLoading } = this.state;
        const { type, updateRights, createRights } = this.props;
        if (type === 'update') {
            if (updateRights)
                return (
                    <FormEditButton
                        formDisabled={formDisabled}
                        handleEdit={this.handleEdit}
                        confirmEdit={this.confirmEdit}
                        sendLoading={sendLoading}
                    />
                );
        } else if (createRights) {
            return <FormSaveButton sendFunc={this.saveUserManager} sendLoading={sendLoading} />;
        }
    }

    navigateToManagementDetail = id => {
        const { history, managementDetailsRights } = this.props;
        if (managementDetailsRights) {
            return history.push({ pathname: `/${history.environment}/management/detail/${id}` });
        }
    };

    render() {
        const { textInput_error, formDisabled, userManagerForm, passwordReseting, codeGenerating, sendLoading } = this.state;
        const { userManager, managementsArray, updateRights, resetPassRights, type } = this.props;

        return (
            <Fragment>
                <FHETitle
                    title={
                        type === 'update'
                            ? `${userManager.get('firstname')} ${userManager.get('lastname')}`
                            : Translator.translate('general.addUserManager')
                    }
                    Icon={SvgCraftsman}
                />
                {updateRights && <FormButtonContainer sendLoading={sendLoading} buttons={this.renderButtons()} />}
                <FHEContainerScroll>
                    <FHEContainerForm>
                        <Grid container spacing={3}>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHETextField
                                    disabled={formDisabled}
                                    id="firstname"
                                    value={userManagerForm.firstname}
                                    error={textInput_error.firstname}
                                    label={Translator.translate('general.table.column.firstname')}
                                    name="firstname"
                                    onChange={this.handleChange}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHETextField
                                    disabled={formDisabled}
                                    id="lastname"
                                    value={userManagerForm.lastname}
                                    error={textInput_error.lastname}
                                    label={Translator.translate('general.table.column.lastname')}
                                    name="lastname"
                                    onChange={this.handleChange}
                                />
                            </Grid>
                            {type === 'update' && resetPassRights && (
                                <Grid container item sm={12} md={6} lg={4}>
                                    <FHEButton
                                        content={Translator.translate('generic.userManager.actions.resetPassword')}
                                        clickFunction={this.askResetPassword}
                                        loading={passwordReseting}
                                        disabled={passwordReseting}
                                    />
                                </Grid>
                            )}
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHETextField
                                    disabled={formDisabled}
                                    id="email"
                                    value={userManagerForm.email}
                                    error={textInput_error.email}
                                    label={Translator.translate('general.table.column.email')}
                                    name="email"
                                    onChange={this.handleChange}
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEReactSelect
                                    name="role"
                                    label={Translator.translate('general.table.column.role')}
                                    disabled={formDisabled}
                                    onChange={this.handleReactSelect}
                                    value={this.getSelectedRole(userManagerForm.role)}
                                    choices={this.roles.filter(x => x.value !== 'developper')}
                                    error={textInput_error.role}
                                    closeMenuOnSelect
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHEReactSelect
                                    name="lang"
                                    label={Translator.translate('general.table.column.lang')}
                                    disabled={formDisabled}
                                    onChange={this.handleReactSelect}
                                    value={this.getSelectedLang(userManagerForm.lang)}
                                    choices={this.langs}
                                    error={textInput_error.lang}
                                    closeMenuOnSelect
                                />
                            </Grid>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHETextField
                                    disabled
                                    id="brand"
                                    value={userManagerForm.title}
                                    error={textInput_error.brand}
                                    label={Translator.translate('general.table.column.brand')}
                                    name="brand"
                                    onChange={() => {}}
                                />
                            </Grid>
                            {type === 'update' && (
                                <Grid container item sm={12} md={6} lg={4}>
                                    <FHETextField
                                        disabled
                                        id="code"
                                        value={userManagerForm.code}
                                        error={textInput_error.code}
                                        label={Translator.translate('general.table.column.code')}
                                        name="code"
                                        onChange={() => {}}
                                    />
                                </Grid>
                            )}
                            {type === 'update' && resetPassRights && (
                                <Grid container item sm={12} md={6} lg={4}>
                                    <FHEButton
                                        content={Translator.translate('generic.userManager.actions.generateCode')}
                                        clickFunction={this.askGenerateCode}
                                        loading={codeGenerating}
                                        disabled={codeGenerating}
                                    />
                                </Grid>
                            )}
                            {type === 'add' && (
                                <Grid container item sm={12} md={6} lg={4}>
                                    <FHETextField
                                        disabled={formDisabled}
                                        id="password"
                                        value={userManagerForm.password}
                                        error={textInput_error.password}
                                        label={Translator.translate('general.table.column.password')}
                                        name="password"
                                        onChange={this.handleChange}
                                    />
                                </Grid>
                            )}

                            <Grid container item sm={12} md={12} lg={12}>
                                {type === 'update' && (
                                    <FHEReactSelect
                                        name="managementIds"
                                        label={Translator.translate('general.table.column.managements')}
                                        disabled={formDisabled}
                                        searchable
                                        onChange={this.handleReactSelect}
                                        multiple
                                        value={this.getSelectedManagements(userManagerForm.managementIds)}
                                        choices={managementsArray}
                                        error={textInput_error.managementIds}
                                        onClickLabel={this.navigateToManagementDetail}
                                        closeMenuOnSelect={false}
                                    />
                                )}
                            </Grid>
                        </Grid>
                    </FHEContainerForm>
                </FHEContainerScroll>
            </Fragment>
        );
    }
}

function mapStateToProps(state, props) {
    const { history } = props;
    const selectors = getSelectors(history.environment);

    const userManager = state.environments[history.environment].data.UsersManagers.getIn(['list', props.match.params.userManagerId], new Map());
    const managementsArray = [];
    const managements = state.environments[history.environment].data.Managements.get('list');
    managements.map((management, key) =>
        managementsArray.push({
            value: parseInt(key),
            label: management.get('libelle'),
        }),
    );
    const profile = selectors.getProfile(state);

    return {
        profile,
        userManager,
        managementsArray,
        managements,
        managementDetailsRights: profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('managementDetails'),
        createRights: profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('userManagerAdd'),
        detailsRights: profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('userManagerDetails'),
        updateRights: profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('userManagerDetailsUpdate'),
        resetPassRights: profile.get('admin') || profile.getIn(['user_rights', history.environment], []).includes('userManagerResetPassword'),
    };
}

export default withRouter(renderEnvComponent('scenes/UserManager/Form/FormUserManager', connect(mapStateToProps)(FormUserManager)));



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/UserManager/Form/FormUserManager.js